import React, { PropTypes, Component } from 'react';
import styled from 'styled-components';
import { NitroIcon } from 'nitro-components';
import { RegoPlate } from '../../../components/vehicle';

const TabContainer = styled.div`
display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;`;

const HeaderTab = props => {
	const { value, iconName, iconVariant, iconSize, active } = props;
	return (
		<TabContainer>
			{iconName &&
				<NitroIcon
					name={iconName}
					variant={iconVariant}
					shadow
					size={iconSize}
					right={12}
				/>}
			<RegoPlate value={value} active={active} />
		</TabContainer>
	);
};

HeaderTab.propTypes = {
	value: PropTypes.string,
	iconName: PropTypes.string,
	iconVariant: PropTypes.string,
	iconSize: PropTypes.number,
	active: PropTypes.bool
};

HeaderTab.defaultProps = {
	// defaultProp: ''
};

export default HeaderTab;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/HeaderTab.js